import { createForm } from "../../../forms";

import { customAlertSchema } from "./schema";

import type { CustomAlertForm } from "./types";

const initialValues: CustomAlertForm = {
  model: "transaction",
  deliveryMethod: "email", // Default to email
  greaterThanAmount: null,
  lessThanAmount: null,
  greaterThanBalance: null,
  lessThanBalance: null,
  description: "",
  accounts: [],
};
export const customAlertForm = createForm<CustomAlertForm>({
  initialValues,
  translateValidationSchema: customAlertSchema,
});
